var ChainIconOption;
(function (ChainIconOption) {
    ChainIconOption["ETHEREUM"] = "ethereum";
    ChainIconOption["POLYGON"] = "polygon";
    ChainIconOption["ARBITRUM"] = "arbitrum";
    ChainIconOption["OPTIMISM"] = "optimism";
    ChainIconOption["FANTOM"] = "fantom";
    ChainIconOption["BSC"] = "bsc";
    ChainIconOption["AVALANCHE"] = "avalanche";
})(ChainIconOption || (ChainIconOption = {}));
export { ChainIconOption };
//# sourceMappingURL=IconChain.types.js.map